var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, "max-width": "1200" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Voltar ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", { attrs: { title: _vm.title, subtitle: _vm.subtitle } }),
      _c(
        "div",
        [
          _c("v-data-table", {
            staticClass: "table-new-ux-group-by-v1",
            attrs: {
              headers: _vm.headerCarteiraSimulada,
              items: _vm.ativos,
              "group-by": "classe",
              "hide-default-footer": "",
              "disable-pagination": ""
            },
            scopedSlots: _vm._u([
              {
                key: "group.header",
                fn: function(ref) {
                  var group = ref.group
                  var items = ref.items
                  return [
                    _c("td", { staticClass: "az-text-primary font-semibold" }, [
                      _vm._v(" " + _vm._s(group) + " ")
                    ]),
                    _c("td"),
                    _c("td", { staticClass: "az-text-primary font-semibold" }, [
                      _vm._v(" " + _vm._s(_vm.sumPL(items)) + " ")
                    ]),
                    _c("td", { staticClass: "az-text-primary font-semibold" }, [
                      _vm._v(" " + _vm._s(_vm.sumPercent(items)) + " ")
                    ])
                  ]
                }
              },
              {
                key: "item.referencia",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("div", [
                      _vm._v(
                        " " + _vm._s(item.CNPJ || item.referencia || "") + " "
                      )
                    ])
                  ]
                }
              },
              {
                key: "item.actions",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "div",
                      { staticStyle: { width: "78px" } },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: { icon: "", "x-small": "" },
                                            on: { click: _vm.bloquearAtivo }
                                          },
                                          on
                                        ),
                                        [
                                          _c("icon-svg", {
                                            attrs: {
                                              name: "mdi-cancel",
                                              color: "#8E8E8E",
                                              size: "16"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Bloquear ativo na simulação (não sugerir a compra)"
                              )
                            ])
                          ]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: { icon: "", "x-small": "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.trocarAtivo(item)
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [
                                          _c("icon-svg", {
                                            attrs: {
                                              name: "mdi-shuffle-variant",
                                              color: "#8E8E8E",
                                              size: "16"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_c("span", [_vm._v("Trocar ativo")])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: { icon: "", "x-small": "" },
                                            on: { click: _vm.fixarAtivo }
                                          },
                                          on
                                        ),
                                        [
                                          _c("icon-svg", {
                                            attrs: {
                                              name: "mdi-pin-outline",
                                              color: "#8E8E8E",
                                              size: "16"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_c("span", [_vm._v("Fixar ativo")])]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }